module.exports = __webpack_public_path__ + "media/images/footer/ministere-31d439b7aeffb9236f6bc4556b0bf44f.png";